angular
    .module('editingCenterModule')
    .controller('trillDetailCtrl', [
        '$scope', 
        'item', 
        '$modalInstance', 
        'editingCenterService', 
        'initTrillEditerBtnService',
        function($scope, item, $modalInstance, editingCenterService, initTrillEditerBtnService){
            initData();

            /**
             * [initData 初始化数据]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.item = item;
            }
            
            /**
             * [close 关闭弹窗]
             *
             * @return  {[type]}  [return description]
             */
            $scope.close = function () {
                $modalInstance.dismiss();
            };

            /**
             * [processRecord description]查看流程版本操作日志
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            $scope.processRecord = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [trillEditor description]
             *
             * @param   {[type]}  account     [account description]
             * @param   {[type]}  ariticlid   [ariticlid description]
             * @param   {[type]}  isOriginal  [isOriginal description]
             * @param   {[type]}  platform    [platform description]
             *
             * @return  {[type]}              [return description]
             */
            $scope.trillEditor = function(account, ariticlid, isOriginal, platform) {
                initTrillEditerBtnService.trillEditor(account, ariticlid, isOriginal, platform - 1);
            };
    }]);